var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAiChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8887 2.26367C12.9657 2.0381 13.2843 2.0381 13.3613 2.26367L13.498 2.66211C13.6732 3.17455 14.0754 3.57683 14.5879 3.75195L14.9863 3.88867C15.2119 3.96573 15.2119 4.28427 14.9863 4.36133L14.5879 4.49805C14.0754 4.67317 13.6732 5.07545 13.498 5.58789L13.3613 5.98633C13.2843 6.2119 12.9657 6.2119 12.8887 5.98633L12.752 5.58789C12.5768 5.07544 12.1746 4.67317 11.6621 4.49805L11.2637 4.36133C11.0381 4.28427 11.0381 3.96573 11.2637 3.88867L11.6621 3.75195C12.1746 3.57683 12.5768 3.17455 12.752 2.66211L12.8887 2.26367Z",
    stroke: "#B0BEC5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5V11.625C15.75 12.0228 15.592 12.4044 15.3107 12.6857C15.0294 12.967 14.6478 13.125 14.25 13.125H8.1113C7.24622 13.125 6.42324 13.4984 5.85357 14.1495L4.125 16.125V13.7669C4.125 13.3909 3.86612 13.0643 3.5 12.9786V12.9786C2.76776 12.807 2.25 12.1539 2.25 11.4018V4.125C2.25 3.72718 2.40804 3.34564 2.68934 3.06434C2.97064 2.78304 3.35218 2.625 3.75 2.625H7.875",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiChat2);
export default __webpack_public_path__ + "static/media/icon_ai_chat_2.81f9bfe657dd126f21dd7214b23bdfc8.svg";
export { ForwardRef as ReactComponent };